// extracted by mini-css-extract-plugin
export var infoRow = "_ru-2";
export var labelContainer = "_ru-0";
export var rightInfo = "_ru-1";